import { render } from "./LabeledSelect.vue?vue&type=template&id=0b12d73c&scoped=true"
import script from "./LabeledSelect.vue?vue&type=script&lang=js"
export * from "./LabeledSelect.vue?vue&type=script&lang=js"

import "./LabeledSelect.vue?vue&type=style&index=0&id=0b12d73c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b12d73c"]])

export default __exports__